import {
  styled as muiStyled,
  Stack,
  Typography,
  Divider,
  TextField,
} from '@mui/material';

import styled from 'styled-components';
import { COLORS } from '../../themes/colors';

export const DateContainer = muiStyled(Stack)(() => ({
  flexDirection: 'column',
  width: '100%',
  gap: '8px'
}));

export const PeriodTitle = muiStyled(Typography)(() => ({
  fontFamily: 'Work Sans',
  fontWeight: 600,
  fontSize: '14px',
  color: `${COLORS.DARK['+3']}`,
}));

export const DividerStyled = muiStyled(Divider)(() => ({
  marginTop: '8px',
}));

export const PeriodContent = styled.div`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 8px;
`;

export const DateContent = muiStyled(Stack)(() => ({
  flexDirection: 'row',
  alignItems: 'flex-end',
  justifyContent: 'center',
  gap: '10px',
  width: '100%',
}));

export const TextFieldStyled = muiStyled(TextField)(() => ({
  color: `${COLORS.DARK['+5']}`,
  fontFamily: 'Work Sans',
  fontWeight: 400,
  fontSize: '14px',

  '& .MuiInput-underline:before': {
    borderBottom: `1px solid ${COLORS.DARK['+1']}`,
  },
  '& .MuiInput-underline:after': {
    borderBottomColor: `${COLORS.PRIMARY.BLUE['-4']}`,
  },
}));

export const ToStyled = muiStyled(Typography)(() => ({
  color: `${COLORS.BLACK}`,
  fontFamily: 'Work Sans',
  fontWeight: 400,
  fontSize: '14px',
  marginBottom: '8px',
}));
